module.exports = __webpack_public_path__ + "img/arrow-ios-downward.0c1b749e.svg";